module.exports = __webpack_public_path__ + "img/16d001-04.136217a6.jpg";